import React from 'react';
import { BookOpenIcon, ChatBubbleLeftRightIcon } from '@heroicons/react/24/outline';

const resourceItems = [
  {
    title: "Documentation & Support",
    items: [
      {
        text: "Structured Labs Documentation",
        url: "https://docs.preswald.com"
      },
      {
        text: "GitHub Issues",
        url: "https://github.com/structuredlabs/preswald/issues"
      },
      {
        text: "Quick Start Guide",
        url: "https://docs.preswald.com/quickstart"
      },
      {
        text: "Join Slack Community",
        url: "https://join.slack.com/t/structuredlabs-users/shared_invite/zt-33zwhyv3l-6Xu4bHL6b6~bI3z9fvlUig"
      }
    ],
    icon: BookOpenIcon,
    color: 'text-cyan-500',
    borderColor: 'border-cyan-500',
    hoverBg: 'hover:bg-cyan-50'
  },
  {
    title: "Community",
    items: [
      {
        text: "Slack Community",
        url: "https://join.slack.com/t/structuredlabs-users/shared_invite/zt-33zwhyv3l-6Xu4bHL6b6~bI3z9fvlUig"
      },
      {
        text: "GitHub Discussions",
        url: "https://github.com/structuredlabs/preswald/discussions"
      },
      {
        text: "Twitter Updates",
        url: "https://twitter.com/structuredlabs"
      },
      {
        text: "Mentor Office Hours",
        url: "https://join.slack.com/t/structuredlabs-users/shared_invite/zt-33zwhyv3l-6Xu4bHL6b6~bI3z9fvlUig"
      }
    ],
    icon: ChatBubbleLeftRightIcon,
    color: 'text-green-500',
    borderColor: 'border-green-500',
    hoverBg: 'hover:bg-green-50'
  }
];

const HackathonResources: React.FC = () => {
  return (
    <div className="relative max-w-8xl mx-auto px-4 py-16">
      {/* Semi-transparent overlay */}
      <div className="absolute inset-0 bg-white backdrop-blur-md" />
      
      <div className="relative z-10">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-4">
          Resources & Support
        </h2>
        <p className="text-center text-slate-600 mb-12 max-w-2xl mx-auto">
          Everything you need to build your project. From documentation to community support, we've got you covered.
        </p>
        
        <div className="flex flex-col md:flex-row justify-center items-stretch gap-8">
          {resourceItems.map((item, index) => (
            <div
              key={index}
              className="w-full md:w-[350px] group"
            >
              <div className={`flex flex-col items-center bg-white/50 p-6 border-2 ${item.borderColor} ${item.hoverBg}
                transition-all duration-300 ease-in-out
                hover:shadow-lg hover:-translate-y-2 hover:rotate-2
                group-hover:border-opacity-100 border-opacity-50 h-full`}>
                {/* Icon */}
                <div className={`text-4xl mb-4 transition-transform duration-300 group-hover:scale-110 group-hover:rotate-12 ${item.color}`}>
                  <item.icon className="w-12 h-12" />
                </div>
                
                {/* Text Content */}
                <div className="space-y-4 text-center flex-grow">
                  <h3 className="text-xl font-semibold text-slate-900">
                    {item.title}
                  </h3>
                  <ul className="text-slate-600 space-y-2">
                    {item.items.map((listItem, idx) => (
                      <li key={idx} className="flex items-center justify-center">
                        <span className="mr-2">•</span>
                        <a 
                          href={listItem.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-blue-600 hover:text-blue-800 hover:underline transition-colors"
                        >
                          {listItem.text}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-slate-600">
            Need help?{' '}
            <a
              href="https://join.slack.com/t/structuredlabs-users/shared_invite/zt-33zwhyv3l-6Xu4bHL6b6~bI3z9fvlUig"
              className="text-slate-900 hover:text-slate-700 underline"
              target="_blank"
              rel="noopener noreferrer"
            >
              Join our Slack community
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default HackathonResources; 